import classNames from "classnames";
import { LayoutMainProps, LayoutProps, LayoutSideNavProps, LayoutSideProps } from "./layout.types";
import Header from "../header";

export default function Layout({ showSideFilter = true, ...props }: LayoutProps) {
  return <main className={classNames("consoleLayoutBody", props.className)}>{props.children}</main>;
}

function SideNavWrapper(props: LayoutSideNavProps) {
  return <div className="consoleLayoutSidebar">{props.children}</div>;
}

Layout.Header = function () {
  return <Header />;
};

Layout.Side = function (props: LayoutSideProps) {
  return <SideNavWrapper children={props.children} />;
};

Layout.Main = function (props: LayoutMainProps) {
  return (
    <div className="consoleLayoutContentWrapper">
      <div className="consoleLayoutContainer">{props.children}</div>
    </div>
  );
};
